module.exports = __webpack_public_path__ + "static/media/logo-box.03837ad7.svg";